export const BRAND = {
  name: "Accurate Claims Services",
  short: "Accurate Claims",
  tagline: "Your Claim. Our Expertise. Your Peace of Mind.",
  values: "Care · Faith · Accuracy",
  subline: "Care · Faith · Accuracy",
  phone: "6354379879",
  phoneIntl: "+91 63543 79879",
  phoneE164: "+916354379879",
  email: "contact@accurateclaims.in",
  address: {
    line1: "423, Ratna Business Square",
    line2: "Opposite H.K. College, Ashram Road",
    city: "Ahmedabad",
    state: "Gujarat",
    pincode: "380009",
    country: "India",
  },
  whatsappUrl: "https://wa.me/916354379879?text=Hello%20Accurate%20Claims%2C%20I%20need%20help%20with%20my%20insurance%20claim.",
  telUrl: "tel:+916354379879",
  mailUrl: "mailto:contact@accurateclaims.in",
  logoUrl: "/brand/logo.png",
  hours: "Mon – Sat · 10:00 AM – 7:00 PM",
};

export const SERVICES = [
  {
    slug: "claim-documentation",
    title: "Claim Documentation",
    short: "Review papers, prepare missing documents, present a clean claim file.",
    bullets: ["Review claim papers", "Missing document checklist", "Claim presentation", "Medical chronology", "Document verification"],
    icon: "FileText",
  },
  {
    slug: "claim-review",
    title: "Claim Review",
    short: "Policy wording analysis, gap identification and assessment.",
    bullets: ["Policy wording analysis", "Claim assessment", "Documentation improvement", "Gap identification"],
    icon: "Search",
  },
  {
    slug: "dispute-resolution",
    title: "Claim Dispute Resolution",
    short: "Follow-up on delays, short-settlement reviews and representations.",
    bullets: ["Delay follow-up", "Short settlement review", "Policy interpretation", "Representation support"],
    icon: "Scale",
  },
  {
    slug: "legal-advisory",
    title: "Legal Advisory",
    short: "Consumer rights, IRDAI guidance and Ombudsman support.",
    bullets: ["Consumer rights", "IRDAI guidance", "Insurance Ombudsman", "Legal documentation", "Advocate coordination"],
    icon: "Gavel",
    disclaimer: "Legal services are provided through qualified legal professionals where applicable.",
  },
  {
    slug: "insurance-coordination",
    title: "Insurance Coordination",
    short: "We talk to the insurer so you don't have to.",
    bullets: ["Communication with insurer", "Additional document submission", "Query handling", "Status follow-up"],
    icon: "Handshake",
  },
  {
    slug: "corporate-services",
    title: "Corporate Services",
    short: "Employee claim desks, hospital support and claim audits.",
    bullets: ["Employee claim desk", "Hospital support", "HR claim assistance", "Claim audit"],
    icon: "Building2",
  },
];

export const INDUSTRIES = [
  { name: "Health", icon: "Heart", blurb: "Cashless, reimbursement & rejection appeals." },
  { name: "Life", icon: "ShieldCheck", blurb: "Death, maturity & survival claim disputes." },
  { name: "Motor", icon: "Car", blurb: "Accident, theft & total-loss claims." },
  { name: "Travel", icon: "Plane", blurb: "Trip delay, medical & baggage claims." },
  { name: "Fire", icon: "Flame", blurb: "Property damage & loss-of-profit." },
  { name: "Marine", icon: "Ship", blurb: "Cargo, transit & inland claims." },
  { name: "Property", icon: "Home", blurb: "Home & commercial property settlements." },
  { name: "Commercial", icon: "Briefcase", blurb: "SME & corporate policy claims." },
  { name: "Personal Accident", icon: "Activity", blurb: "Disability & accident benefit claims." },
];

export const WHY_US = [
  { title: "20+ Years Experience", icon: "Award" },
  { title: "Independent Advice", icon: "ShieldCheck" },
  { title: "Transparent Process", icon: "Eye" },
  { title: "Secure Documentation", icon: "Lock" },
  { title: "Professional Team", icon: "Users" },
  { title: "Quick Response", icon: "Zap" },
  { title: "Dedicated Case Manager", icon: "UserCheck" },
  { title: "Confidential Handling", icon: "FileLock2" },
];

export const PROCESS = [
  { step: "01", title: "Book Consultation", body: "Schedule a free 20-minute call with our expert." },
  { step: "02", title: "Upload Documents", body: "Securely share your policy and claim papers." },
  { step: "03", title: "Claim Review", body: "We assess the claim against policy wording." },
  { step: "04", title: "Expert Opinion", body: "Written opinion + improvement plan." },
  { step: "05", title: "Documentation Support", body: "We help build a stronger claim file." },
  { step: "06", title: "Representation", body: "We coordinate with the insurer on your behalf." },
  { step: "07", title: "Resolution", body: "We see your claim through to settlement." },
];

export const STATS = [
  { value: "20+", label: "Years of experience" },
  { value: "5,000+", label: "Claims advised" },
  { value: "₹120 Cr+", label: "Settlements supported" },
  { value: "92%", label: "Resolution success rate" },
];

export const FAQS = [
  { q: "Do you sell insurance policies?", a: "No. We are an independent claim advisory. We represent the policyholder — never the insurer. We do not sell, renew or earn commissions on policies." },
  { q: "Which types of insurance claims do you handle?", a: "Health, Life, Motor, Travel, Fire, Marine, Property, Personal Accident and Commercial claims across both individual and corporate policies." },
  { q: "Can you help with claims that have already been rejected?", a: "Yes. We frequently review rejected, short-settled or delayed claims, identify gaps in documentation, and prepare a representation to the insurer, the Internal Ombudsman or the IRDAI Insurance Ombudsman." },
  { q: "How long does the process take?", a: "Most cases see an initial expert opinion within 48 hours of receiving your documents. Total resolution time depends on the insurer and the complexity of the claim." },
  { q: "How do you charge?", a: "We work on transparent fixed advisory fees disclosed upfront after the initial consultation. There are no hidden commissions." },
  { q: "Is my information secure?", a: "Yes. Documents are stored in encrypted cloud object storage with role-based access. Only your assigned case manager can access your file." },
  { q: "Do you serve clients outside Gujarat?", a: "Currently we serve clients across Gujarat in Phase 1, with select Pan-India support for corporate accounts and senior citizens. Pan-India expansion is on the roadmap." },
  { q: "Do I have to visit your office?", a: "No. The entire process can be completed online via our client portal — including uploads, status tracking, expert opinions and updates. In-person meetings at our Ahmedabad office are available on request." },
  { q: "Will you handle legal proceedings on my behalf?", a: "Legal proceedings, where required, are handled by qualified advocates we coordinate with. We are not a law firm; we are claim advisors." },
  { q: "Do you support hospitals and HR teams?", a: "Yes — through our Corporate Services we run employee claim desks, hospital support cells and end-to-end claim audits for SMEs and large companies." },
];

export const VALUES = [
  "Integrity",
  "Respect",
  "Transparency",
  "Commitment",
  "Accuracy",
  "Trust",
  "Professionalism",
];

export const TESTIMONIALS = [
  {
    name: "Mehul Patel",
    role: "Health claim, Ahmedabad",
    body: "My ₹4.2L mediclaim was rejected as a pre-existing condition. Accurate Claims rebuilt the file with the right medical chronology — settled in 6 weeks.",
  },
  {
    name: "Rina Shah",
    role: "Motor claim, Surat",
    body: "Insurer offered a short settlement. The team's policy-wording analysis got me 38% more on the final cheque. Worth every rupee.",
  },
  {
    name: "Dr. Anil Mehta",
    role: "Hospital Administrator",
    body: "We run our employee claim desk through Accurate Claims now. Clean process, dedicated case manager, fewer angry phone calls.",
  },
];
